import { c as _c } from "react/compiler-runtime";
import { getPrivateAccessRequestsOptions } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';
import { isAfter, parseISO } from 'date-fns';
import uniq from 'lodash/uniq';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSession from '@/hooks/use-session';
const useAssumeBanner = () => {
  const $ = _c(44);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.privateLayout.assumeBanner"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const [showEditRightsForm, setShowEditRightsForm] = useState(false);
  const router = useRouter();
  const {
    data,
    isAssumedSessionEditMode,
    setAssumedSessionEditMode
  } = useSession();
  const {
    user,
    org
  } = data;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getPrivateAccessRequestsOptions();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = Boolean(user?.isFirmEmployee);
  let t3;
  if ($[2] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    data: accessRequests,
    isPending: isAccessRequestsPending
  } = useQuery(t3);
  let t4;
  if ($[4] !== accessRequests || $[5] !== org?.id || $[6] !== user?.email) {
    t4 = accessRequests?.some(request => request.approved && request.requester === user?.email && request.tenantId === org?.id && isAfter(parseISO(request.expiresAt), new Date()));
    $[4] = accessRequests;
    $[5] = org?.id;
    $[6] = user?.email;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const hasApprovedAccessRequest = t4;
  let canEnableEditMode;
  let currentPermissions;
  let t5;
  if ($[8] !== accessRequests || $[9] !== hasApprovedAccessRequest || $[10] !== org?.id || $[11] !== org?.isSandboxRestricted || $[12] !== user?.email || $[13] !== user?.isCxOpsEmployee || $[14] !== user?.isFirmEmployee || $[15] !== user?.isRiskOpsEmployee) {
    currentPermissions = uniq(accessRequests?.filter(request_0 => request_0.approved && request_0.requester === user?.email && request_0.tenantId === org?.id && isAfter(parseISO(request_0.expiresAt), new Date()))?.flatMap(_temp)?.map(_temp2) || []);
    const tenantIsSandboxRestricted = org?.isSandboxRestricted && user?.isFirmEmployee;
    canEnableEditMode = user?.isRiskOpsEmployee || user?.isCxOpsEmployee || hasApprovedAccessRequest || tenantIsSandboxRestricted;
    t5 = canEnableEditMode && !currentPermissions.includes("admin");
    $[8] = accessRequests;
    $[9] = hasApprovedAccessRequest;
    $[10] = org?.id;
    $[11] = org?.isSandboxRestricted;
    $[12] = user?.email;
    $[13] = user?.isCxOpsEmployee;
    $[14] = user?.isFirmEmployee;
    $[15] = user?.isRiskOpsEmployee;
    $[16] = canEnableEditMode;
    $[17] = currentPermissions;
    $[18] = t5;
  } else {
    canEnableEditMode = $[16];
    currentPermissions = $[17];
    t5 = $[18];
  }
  const canRequestAdditionalPermissions = t5;
  const isAssumedSession = !!user?.isAssumedSession;
  let t6;
  if ($[19] !== canEnableEditMode || $[20] !== isAssumedSessionEditMode || $[21] !== setAssumedSessionEditMode) {
    t6 = () => {
      if (isAssumedSessionEditMode) {
        setAssumedSessionEditMode(false);
      } else {
        if (canEnableEditMode) {
          setAssumedSessionEditMode(true);
        } else {
          setShowEditRightsForm(true);
        }
      }
    };
    $[19] = canEnableEditMode;
    $[20] = isAssumedSessionEditMode;
    $[21] = setAssumedSessionEditMode;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  const handleChangeEdit = t6;
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setShowEditRightsForm(true);
    };
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const handleRequestAdditionalPermissions = t7;
  let t8;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setShowEditRightsForm(false);
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const handleCloseEditRightsForm = t8;
  let t9;
  if ($[25] !== router) {
    t9 = () => router.push({
      pathname: "/logout"
    });
    $[25] = router;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const handleLogout = t9;
  let t10;
  if ($[27] !== canEnableEditMode || $[28] !== isAssumedSessionEditMode || $[29] !== t) {
    t10 = () => {
      if (isAssumedSessionEditMode) {
        return t(_temp3);
      }
      if (canEnableEditMode) {
        return t(_temp4);
      }
      return t(_temp5);
    };
    $[27] = canEnableEditMode;
    $[28] = isAssumedSessionEditMode;
    $[29] = t;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  const getEditButtonText = t10;
  let t11;
  if ($[31] !== canEnableEditMode || $[32] !== canRequestAdditionalPermissions || $[33] !== currentPermissions || $[34] !== getEditButtonText || $[35] !== handleChangeEdit || $[36] !== handleLogout || $[37] !== isAccessRequestsPending || $[38] !== isAssumedSession || $[39] !== isAssumedSessionEditMode || $[40] !== org || $[41] !== showEditRightsForm || $[42] !== t) {
    t11 = {
      t,
      showEditRightsForm,
      currentPermissions,
      isAssumedSession,
      isAssumedSessionEditMode,
      isAccessRequestsPending,
      canEnableEditMode,
      canRequestAdditionalPermissions,
      org,
      handleChangeEdit,
      handleCloseEditRightsForm,
      handleRequestAdditionalPermissions,
      handleLogout,
      getEditButtonText
    };
    $[31] = canEnableEditMode;
    $[32] = canRequestAdditionalPermissions;
    $[33] = currentPermissions;
    $[34] = getEditButtonText;
    $[35] = handleChangeEdit;
    $[36] = handleLogout;
    $[37] = isAccessRequestsPending;
    $[38] = isAssumedSession;
    $[39] = isAssumedSessionEditMode;
    $[40] = org;
    $[41] = showEditRightsForm;
    $[42] = t;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  return t11;
};
export default useAssumeBanner;
function _temp(request_1) {
  return request_1.scopes;
}
function _temp2(scope) {
  return scope.kind;
}
function _temp3($) {
  return $.disableEdit;
}
function _temp4($_0) {
  return $_0.enableEdit;
}
function _temp5($_1) {
  return $_1.requestEditMode;
}